export const DISCLOSURE_TWO_LINK =
  'https://quashed.co.nz/documents/Disclosure%20Two.pdf';

export const AUTOSURE_POLICY_WORDING_LINK =
  'https://quashed.co.nz/policy-wordings/turners/autosure_parts_list_a4_052024.pdf';

export const AUTOSURE_MBI_POLICY_WORDING_ADVANTAGE_PLUS_LINK =
  'https://quashed.co.nz/policy-wordings/autosure/mbi_advantage_plus.pdf';
export const AUTOSURE_MBI_POLICY_WORDING_ADVANTAGE_LINK =
  'https://quashed.co.nz/policy-wordings/autosure/mbi_advantage.pdf';
